import { produce } from 'immer';
import _ from 'lodash';
import { Dispatch, SetStateAction } from 'react';
import { hasValidationErrors } from '../../../../../../common/global/helpers';
import Input from '../../../../../../common/widgets/Input';
import { CustomFieldModel } from '../../../../models/EmployeeDetailsModel';
import { ErrorState } from '../../../../models/Errors';
import { EditEmployeeState } from './EditEmployeeState';

export const mapCustomField = (
  customField: CustomFieldModel,
  state: EditEmployeeState,
  setState: Dispatch<SetStateAction<EditEmployeeState>>,
  errors: ErrorState,
) => {
  const propName = _.camelCase(customField.label);
  const hasErrors = hasValidationErrors(errors, propName);
  return (
    <div className="col col-6 col-xxs-12">
      <Input
        key={customField.fieldId}
        label={customField.label}
        value={state.customFieldsValues[customField.fieldId] ?? ''}
        onChange={e => {
          setState(
            produce(d => {
              if (d?.employee)
                d.customFieldsValues[customField.fieldId] = e.value;
            }),
          );
        }}
        mandatory={customField.isRequired}
        errors={hasErrors ? errors[propName] : []}
      />
    </div>
  );
};
